import { TGlobalState } from '@types';

export const commonReducerSelector = (state: TGlobalState) => state.common
